import IconEmoji from '../../components/IconEmoji'
import IconSend from '../../components/IconSend'
import IconCheck from '../../components/IconCheck'
import IconPointer from '../../components/IconPointer'
import IconChevron from '../../components/IconChevron'
import IconClear from '../../components/IconClear'
import AvatarRobot from '../../components/AvatarRobot'
import Message from '../../components/Message'
import Typing from '../../components/Typing'
import Bar from '../../components/Bar'
import Facebook from '../../components/social/Facebook'
import Twitter from '../../components/social/Twitter'
import game from '../../assets/data/game.json'
import result1 from '../../assets/data/result1.json'
import countriesData from '../../assets/data/countries.json'
import axios from 'axios'

export default {
  name: 'chat',
  components: {
    IconEmoji,
    IconSend,
    IconCheck,
    IconPointer,
    IconChevron,
    IconClear,
    AvatarRobot,
    Message,
    Typing,
    Bar,
    Facebook,
    Twitter
  },
  props: [],
  data () {
    return {
      allowScroll: true,
      questionStart: 1,
      debugResults: false,
      messages: [],
      /*
      messages:
        [{
            "id": 1,
            "next": 2,
            "action": "name",
            "name": "Robot",
            "avatar": "robot.svg",
            "body": "Hi! I’m a robot that finds out what the future of politics looks like for you. Can you please tell me your name?"
          },
          {
            "id": 2,
            "next": 3,
            "name": "You",
            "avatar": "you.svg",
            "body": "Qwr."
          },
          {
            "id": 3,
            "next": 4,
            "action": "country",
            "name": "Robot",
            "avatar": "robot.svg",
            "body": "Thanks Qwr! Where do you live?"
          },
          {
            "id": 4,
            "next": 5,
            "name": "You",
            "avatar": "you.svg",
            "body": "Afghanistan."
          },
          {
            "id": 5,
            "prompt": 901,
            "name": "Robot",
            "avatar": "robot.svg",
            "body": "Afghanistan. Lovely in the summer. But enough small talk, let's get to our thing: the world in 2050. Do you think the government there will be closer to people?"
          },
          {
            "id": 6,
            "next": 11,
            "axis": "x",
            "dimension": "local",
            "name": "You",
            "avatar": "you.svg",
            "body": "Definitely, governments are going to be local and closer."
          },
          {
            "id": 11,
            "prompt": 902,
            "axis": "y",
            "name": "Robot",
            "avatar": "robot.svg",
            "body": "The world is changing quickly! And do you think micro-targeting trough big platforms could transform our votes?"
          },
          {
            "id": 14,
            "next": 17,
            "axis": "y",
            "dimension": "small",
            "name": "You",
            "avatar": "you.svg",
            "body": "No. Things will stay pretty much the same."
          },
          {
            "id": 17,
            "prompt": 903,
            "axis": "x",
            "name": "Robot",
            "avatar": "robot.svg",
            "body": "To be expected. Afghanistan is gorgeous but do you think that, if you wanted to move to another country, it will be easier than today?"
          },
          {
            "id": 21,
            "next": 23,
            "axis": "x",
            "dimension": "local",
            "name": "You",
            "avatar": "you.svg",
            "body": "No, it will be harder. "
          },
          {
            "id": 23,
            "prompt": 904,
            "axis": "x",
            "name": "Robot",
            "avatar": "robot.svg",
            "body": "And would you say immigrants will be well received in Afghanistan in 2050?"
          },
          {
            "id": 26,
            "next": 29,
            "axis": "x",
            "dimension": "local",
            "name": "You",
            "avatar": "you.svg",
            "body": "No, people wil not welcome immigrants."
          },
          {
            "id": 29,
            "next": 32,
            "name": "Robot",
            "avatar": "robot.svg",
            "body": "Well, it's not easy."
          },
          {
            "id": 32,
            "prompt": 905,
            "axis": "y",
            "name": "Robot",
            "avatar": "robot.svg",
            "body": "Let's talk about companies. Today, 10% of firms earn 80% of proft. Will these large firms grow or become atomized?"
          },
          {
            "id": 33,
            "next": 36,
            "axis": "y",
            "dimension": "big",
            "name": "You",
            "avatar": "you.svg",
            "body": "They will grow, very big mega corporations."
          },
          {
            "id": 36,
            "prompt": 906,
            "axis": "y",
            "name": "Robot",
            "avatar": "robot.svg",
            "body": "Do you think that the gig economy will continue raising or is it just a transitory trend?"
          },
          {
            "id": 37,
            "next": 40,
            "axis": "y",
            "dimension": "small",
            "name": "You",
            "avatar": "you.svg",
            "body": "It will raise, for sure."
          },
          {
            "id": 40,
            "prompt": 907,
            "axis": "y",
            "name": "Robot",
            "avatar": "robot.svg",
            "body": "So we can buy our same cola drink everywhere. And what about the relationship between firms and governments?"
          },
          {
            "id": 43,
            "next": 46,
            "axis": "y",
            "dimension": "small",
            "name": "You",
            "avatar": "you.svg",
            "body": "Governments will be powerful enough to regulate firms."
          },
          {
            "id": 46,
            "prompt": 908,
            "axis": "x",
            "name": "Robot",
            "avatar": "robot.svg",
            "body": "Hurray for governments. Let's think about cities. We've seen some of them raise their voices now. Will they become more powerful?"
          },
          {
            "id": 50,
            "next": 54,
            "axis": "x",
            "dimension": "same",
            "name": "You",
            "avatar": "you.svg",
            "body": "Cities will take the lead in key issues but power will remain with national governments."
          },
          {
            "id": 54,
            "prompt": 909,
            "axis": "x",
            "name": "Robot",
            "avatar": "robot.svg",
            "body": "Not much will change then. Do you think regional blocs such as the EU will still make decisions in 2050?"
          },
          {
            "id": 56,
            "next": 59,
            "axis": "x",
            "dimension": "global",
            "name": "You",
            "avatar": "you.svg",
            "body": "Sure, they will regulate issues, such as AI and climate change."
          },
          {
            "id": 59,
            "prompt": 910,
            "axis": "x",
            "name": "Robot",
            "avatar": "robot.svg",
            "body": "We can go further and imagine new radically different institutions will be created, like a global parliament?"
          },
          {
            "id": 65,
            "next": 68,
            "axis": "x",
            "dimension": "local",
            "name": "You",
            "avatar": "you.svg",
            "body": "There will be not such thing, this is not Star Wars."
          },
          {
            "id": 68,
            "next": 70,
            "name": "Robot",
            "avatar": "robot.svg",
            "body": "Of course, I'm letting my imagination flies. You are talking with a robot though, so who knows... anyway, thank you for all this enlightening information!"
          },
          {
            "id": 70,
            "prompt": 911,
            "name": "Robot",
            "avatar": "robot.svg",
            "body": "And for the grand finale, I have a little surprise. Do you want to know which world do you think we are going to, Qwr?"
          },
          {
            "id": 71,
            "next": 73,
            "name": "You",
            "avatar": "you.svg",
            "body": "Oh my, of course!"
          },
          {
            "id": 73,
            "next": -1,
            "action": "results",
            "name": "",
            "avatar": "",
            "body": "This is really goodbye. Such a shame, I was starting to feel fond of you. Here you have your vision of the future, go ahead and share it with the world. See you in ten years!"
          }
        ],
      */
      inputting: false,
      inputAction: null,
      prompting: false,
      prompt: null,
      selectedPrompt: null,
      typing: false,
      delayThinking: 1000,
      delayTyping: 2500,
      maxBarSize: 200,
      name: null,
      place: null,
      hideArrow: false,
      sharing: false,
      shared: false,
      typeString: '',
      skipTyping: [1, 2, 244],
      results: {
        x: {
          local: 0,
          global: 0,
          same: 0,
          na: 0
        },
        y: {
          big: 0,
          small: 0,
          same: 0,
          na: 0
        }
      },/*
      results: {
        concentration_of_power: [],
        socioeconomic_inclusion: [],
        size_firms: [],
        gloal_coordination: []
      },
      resultsAverage: {
        concentration_of_power: [],
        socioeconomic_inclusion: [],
        size_firms: [],
        gloal_coordination: []
      },*/
      resultPhrase: null,
      loadedAverages: false,
      loadingAverages: false,
      averages: {
        concentrationOfPower: 0,
        socioeconomicInclusion: 0,
        sizeFirms: 0,
        globalCoordination: 0
      },
      scores: null,
      displayScores: false,
      barsHighlight: null,
      displayAverage: false
    }
  },
  computed: {
    shareUrl () {
      return process.env.VUE_APP_SHARE_URL
    },
    countries () {
      return countriesData
    },
    previousMessage () {
      return this.messages[this.messages.length - 2] ? this.messages[this.messages.length - 2].id : null
    },
    currentMessage () {
      return this.messages[this.messages.length - 1] ? this.messages[this.messages.length - 1].id : null
    },
    nextMessage () {
      return this.messages[this.messages.length - 1]
        ? this.messages[this.messages.length - 1].next ? this.messages[this.messages.length - 1].next : null
        : null
    },
    nextPrompt () {
      return this.messages[this.messages.length - 1]
        ? this.messages[this.messages.length - 1].prompt ? this.messages[this.messages.length - 1].prompt : null
        : null
    },
    currentPrompt () {
      return this.prompt
    },
    currentSpeaker () {
      if (this.currentMessage) {
        return this.messages.find(item => item.id === this.currentMessage).name
      }
    },
    nextSpeaker() {
      if (this.nextMessage) {
        return game.find(item => item.id === this.nextMessage).name
      }
    }
  },
  mounted () {
    this.start()
    //this.processAction('results')
  },
  methods: {
    startOver () {
      this.name = null
      this.place = null
      this.messages = []
      this.displayScores = false
      this.results.x.global = 0
      this.results.x.local = 0
      this.results.x.same = 0
      this.results.y.small = 0
      this.results.y.big = 0
      this.results.y.same = 0
      this.start()
      console.log('here', this.messages)
    },
    start () {
      this.name = null
      this.place = null
      if (this.debugResults) {
        this.messages = result1
        setTimeout(() => {
          this.buildResults()
        }, 2000)
      } else {
        this.typeMessage(this.questionStart)
      }
    },
    capitalize (str) {
      if (!str) return
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    randomizeTime (time) {
      return (time * 0.1) + (Math.random() * time * 0.9)
    },
    typeMessage (id) {
      if (this.skipTyping.includes(id)) {
        this.loadMessage(id)
      } else {
        setTimeout(() => {
          if (this.nextSpeaker === 'Robot') {
            this.typing = true
          }
          this.scroll()
          setTimeout(() => {
            this.typing = false
            this.loadMessage(id)
          }, this.randomizeTime(this.delayTyping))
        }, 1000 + this.delayThinking)
      }
    },
    loadMessage (id) {
      let message = game.find(item => item.id === id)
      if (message) {
        this.queueMessage(message)
        if (message.action) {
          this.processAction(message.action)
        } else {
          this.loadNext()
        }
      } else {
        console.warn('Message not found: ' + id) /* eslint disable */
      }
    },
    loadNext () {
      if (this.nextMessage) {
        this.typeMessage(this.nextMessage)
      } else {
        this.showPrompt(this.nextPrompt)
      }
    },
    processAction (action) {
      switch (action) {
        case 'name':
          this.inputting = true
          this.inputAction = 'name'
          break
        case 'country':
          this.inputting = true
          this.inputAction = 'country'
          break
        case 'results':
          // setTimeout(() => {
            this.buildResults()
          //}, 3000)
          break
      }
    },
    inputFinished () {
      this.inputting = false
      this.loadNext()
    },
    showPrompt (id) {
      setTimeout(() => {
        this.prompting = true
        let prompt = game.find(item => item.id === id)
        this.prompt = prompt
        this.scroll()
      }, 500)
    },
    clearPrompt () {
      this.prompting = false
      this.prompt = null
      this.selectedPrompt = null
      this.typeString = ''
    },
    answer (message) {
      this.selectedPrompt = message
      this.typeString = message.body

      
    },
    queueMessage (message) {
      message.body = this.parseBody(message.body)
      this.messages = [...this.messages, message]

      /*
      this.results.x.global = 0
      this.results.x.local = 0
      this.results.x.same = 0
      this.results.y.small = 0
      this.results.y.big = 0
      this.results.y.same = 0
      this.messages.forEach(item => {
        if (item.axis) {
          if (item.axis === 'x' && item.dimension) {
            console.log('x', item.dimension, item)
            this.results.x[item.dimension]++
          } else if (item.axis === 'y' && item.dimension) {
            console.log('y', item.dimension, item)
            this.results.y[item.dimension]++
          }
        }
      })
      */

      this.scroll()
    },
    parseBody (body) {
      body = body.replace('${name}', this.capitalize(this.name)) // eslint-disable-line
      body = body.replace('${place}', this.place) // eslint-disable-line
      return body
    },
    scroll () {
      this.$nextTick(() => {
        if (this.allowScroll) {
          this.$el.querySelector('#chat').scrollTop = this.$el.querySelector('#chat').scrollHeight
        }
      })
    },
    onTyped () {
      this.queueMessage(this.selectedPrompt)
      this.clearPrompt()
      this.loadNext()
    },
    buildResults () {
      // console.log(this.messages)

      

      /*
      let scores = this.messages.filter(item => item.score)
      scores.forEach(item => {
        this.results[item.area].push(item)
      })

      let resultPhrases = [{ ref: null, body: this.parseBody('So ${name}, your\'re imagining a future where') }] // eslint-disable-line

      // let concentrationOfPowerAverage = this.getAnswersAverage(this.results.concentration_of_power)
      let concentrationOfPowerAggregated = this.getAnswersAggregated(this.results.concentration_of_power)
      if (concentrationOfPowerAggregated <= 60 && concentrationOfPowerAggregated > 30) {
        resultPhrases.push({ ref: 'bar1', body: 'the concentration of power is high,' })
      } else if (concentrationOfPowerAggregated <= 30 && concentrationOfPowerAggregated > 1) {
        resultPhrases.push({ ref: 'bar1', body: 'the concentration of power is low,' })
      } else {
        resultPhrases.push({ ref: 'bar1', body: 'you don\'t know what happen with concentration of power,' })
      }

      // let socioeconomicInclusionAverage = this.getAnswersAverage(this.results.socioeconomic_inclusion)
      let socioeconomicInclusionAggregated = this.getAnswersAggregated(this.results.socioeconomic_inclusion)
      if (socioeconomicInclusionAggregated <= 60 && socioeconomicInclusionAggregated > 30) {
        resultPhrases.push({ ref: 'bar2', body: 'there\'s greater socioeconomic inclusion,' })
      } else if (socioeconomicInclusionAggregated <= 30 && socioeconomicInclusionAggregated > 1) {
        resultPhrases.push({ ref: 'bar2', body: 'there is less socioeconomic inclusion,' })
      } else {
        resultPhrases.push({ ref: 'bar2', body: 'you have no idea about socioeconomic inclusion,' })
      }

      // let sizeFirmsAverage = this.getAnswersAverage(this.results.size_firms)
      let sizeFirmsAggregated = this.getAnswersAggregated(this.results.size_firms)
      if (sizeFirmsAggregated === 0) {
        resultPhrases.push({ ref: 'bar3', body: 'who knows about size of firms?' })
      } else {
        if (this.results.size_firms[0].score === 30) {
          resultPhrases.push({ ref: 'bar3', body: 'a few big' })
        } else if (this.results.size_firms[0].score === 10) {
          resultPhrases.push({ ref: 'bar3', body: 'lots of small' })
        }
        if (this.results.size_firms[1].score === 30) {
          resultPhrases.push({ ref: 'bar3', body: 'integrated firms,' })
        } else if (this.results.size_firms[1].score === 25) {
          resultPhrases.push({ ref: 'bar3', body: 'specialized firms,' })
        } else if (this.results.size_firms[1].score === 10) {
          resultPhrases.push({ ref: 'bar3', body: 'integrated firms,' })
        } else if (this.results.size_firms[1].score === 15) {
          resultPhrases.push({ ref: 'bar3', body: 'specialized firms,' })
        }
        if (this.results.size_firms[2].score === 30) {
          resultPhrases.push({ ref: null, body: 'we buy global products,' })
        } else if (this.results.size_firms[2].score === 10) {
          resultPhrases.push({ ref: null, body: 'we buy local products,' })
        }
      }

      // let globalCoordinationAverage = this.getAnswersAverage(this.results.gloal_coordination)
      let globalCoordinationAggregated = this.getAnswersAggregated(this.results.gloal_coordination)
      if (globalCoordinationAggregated <= 100 && globalCoordinationAggregated > 60) {
        resultPhrases.push({ ref: 'bar4', body: 'and there\'s a lot of global coordination.' })
      } else if (globalCoordinationAggregated <= 60 && globalCoordinationAggregated > 30) {
        resultPhrases.push({ ref: 'bar4', body: 'and there\'s some global coordination.' })
      } else if (globalCoordinationAggregated <= 30 && globalCoordinationAggregated > 1) {
        resultPhrases.push({ ref: 'bar4', body: 'and you think there\'s little global coordination.' })
      } else {
        resultPhrases.push({ ref: 'bar4', body: 'and you are clueless about global coordination.' })
      }

      /*
      let concentrationOfPowerAggregated = this.results.concentration_of_power.reduce((total, item) => item.score, 0)
      let socioeconomicInclusionAggregated = this.results.socioeconomic_inclusion.reduce((total, item) => item.score, 0)
      let sizeFirmsAggregated = this.results.size_firms.reduce((total, item) => item.score, 0)
      let globalCoordinationAggregated = this.results.gloal_coordination.reduce((total, item) => item.score, 0)
      */

      // this.saveScores(scores)
      /*
      this.scores = {
        resultPhrases: resultPhrases,
        aggregated: {
          concentrationOfPower: concentrationOfPowerAggregated,
          socioeconomicInclusion: socioeconomicInclusionAggregated,
          sizeFirms: sizeFirmsAggregated,
          globalCoordination: globalCoordinationAggregated
        }
      }
      this.displayScores = true

      this.$nextTick(() => {
        let resultsHeight = this.$refs.results.offsetHeight
        let windowHeight = window.innerHeight
        if (windowHeight >= resultsHeight) {
          this.hideArrow = true
        }
      })
      */


      /*
      this.results.x.global = 0
      this.results.x.local = 0
      this.results.x.same = 0
      this.results.y.small = 0
      this.results.y.big = 0
      this.results.y.same = 0
      */
      this.messages.forEach(item => {
        if (item.axis) {
          if (item.axis === 'x' && item.dimension) {
            // console.log('x', item.dimension, item)
            this.results.x[item.dimension]++
          } else if (item.axis === 'y' && item.dimension) {
            // console.log('y', item.dimension, item)
            this.results.y[item.dimension]++
          }
        }
      })


      

      // special cases
      // row 19
      if (this.results.x.local === 2 && this.results.x.global === 2 && this.results.x.same === 2 && this.results.y.big >= 1) {
        this.resultPhrase = "You think there's evidence to think that economy will be dominated by a few mega companies, but you can't decide wether governments are going to be global, local or remain national. Do you want to explore the futures of governance that we foresee? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a>."
      } 
      // row 20
      else if (this.results.x.local === 2 && this.results.x.global === 2 && this.results.x.same === 2 && this.results.y.small >= 1) {
        this.resultPhrase = "You think there's evidence to think that there will be a network of small companies, but you can't decide wether governments are going to be global, local or remain national. Do you want to explore the futures of governance that we foresee? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a>."
      }
      // row 21
      else if (this.results.x.local === 3 && this.results.x.global === 3 && this.results.y.big >= 1) {
        this.resultPhrase = "You think there's evidence to think that economy will be dominated by a few mega companies, but you can't decide wether governments are going to be global or local. Do you want to explore the futures of governance that we foresee? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a>."
      }
      // row 22
      else if (this.results.x.local === 3 && this.results.x.global === 3 && this.results.y.small >= 1) {
        this.resultPhrase = "You think there's evidence to think that there will be a network of small companies, but you can't decide wether governments are going to be global or local. Do you want to explore the futures of governance that we foresee? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a>."
      }
      // row 23 
      else if (this.results.y.big === 2 && this.results.y.small === 2 && this.results.x.global >= 1) {
        this.resultPhrase = "You think there's evidence to think that governance will occur trough global institutions, but you can't decide wether firms are going to be big or small. Do you want to explore the futures of governance that we foresee? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a>."
      }
      // row 24 
      else if (this.results.y.big === 2 && this.results.y.small === 2 && this.results.x.local >= 1) {
        this.resultPhrase = "You think there's evidence to think that governments are going to be local, but you can't decide wether firms are going to be big or small. Do you want to explore the futures of governance that we foresee? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a>."
      }
      // row 25 
      else if (this.results.x.global === 3 && this.results.x.local === 3 && this.results.y.small === 2 && this.results.y.big === 2) {
        this.resultPhrase = "You really can't decide wether governments are going to be local or global, or firms are going to get bigger or smaller. It's so hard to take a guess! Do you want to explore some insights about the futures of governance that we foresee? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a>."
      }
      // row 26
      else if (this.results.x.na === 6 || this.results.y.na === 4) {
        this.resultPhrase = "You really don't have a clue about what's coming. It's so hard to take a guess! Do you want to explore some insights about the futures of governance that we foresee? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a>."
      }
      else {
        // Big foot in a local world 
        // row 2
        if (this.results.x.local >= 3 && this.results.y.big >= 2) {
          this.resultPhrase = "You imagine a future that we call <span class='world'>Big foot in a local world</span>: cities competing for private investment and inequality, both regional and individual, going deeper. How is citizenship going to look like in this private-paced world? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to learn more.";
        }
        // row 3
        else if (this.results.x.local <= 2 && this.results.y.big === 1) {
          if (this.results.x.na >= 3) {
            this.resultsPhrase = "You think there's some evidence the future will look like what we call <span class='world'>Big foot in a local world</span>: cities competing for private investment and inequality growing. But it's hard to tell right? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore about other worlds that may come."
          } else if (this.results.y.na >= 2) {
            this.resultPhrase = "You think there's some evidence the future will look like what we call <span class='world'>Big foot in a local world</span>: cities competing for private investment and inequality growing. But it's hard to tell right? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore about other worlds that may come."
          } else {
            this.resultPhrase = "You think there's some evidence the future will look like what we call <span class='world'>Big foot in a local world</span>: cities competing for private investment and inequality growing. But you are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          }
        }
        // row 4
        else if (this.results.x.local >= 3 && this.results.y.big === 1) {
          if (this.results.y.na >= 2) {
            this.resultPhrase = "You think there's some evidence the future will look like what we call <span class='world'>Big foot in a local world</span>: cities competing for private investment and inequality growing. But it's hard to tell when it comes to firms, right? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore about other worlds that may come."
          } else {
            this.resultPhrase = "You imagine a future where strong cities take the lead in a private-paced scenario. We call this <span class='world'>Big foot in a local world</span>. But you are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          }
        }
        // row 5
        else if (this.results.x.local <= 2 && this.results.y.big >= 2) {
          if (this.results.x.na >= 3) {
            this.resultsPhrase = "You think there's some evidence the future will look like what we call <span class='world'>Big foot in a local world</span>: cities competing for private investment and inequality growing. But it's hard to tell when it comes to governments, right? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore about other worlds that may come."
          } else {
            if (this.results.x.global >= 2) {
              this.resultPhrase = "You imagine a future where mega companies rules and are somehow counterweighted by a few supranational institutions. We call this <span class='world'>The big friendly giant</span>. But you are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
            } else {
              this.resultPhrase = "You imagine a future where a few mega companies rule over a fragmented yet still nation-state based scenario. We call it <span class='world'>Big foot in a local world</span>. But you are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
            }
          }
        }

        // Big friendly giant
        // row 6
        else if (this.results.x.global >= 3 && this.results.y.big >= 2) {
          this.resultPhrase = "You imagine a future that we call <span class='world'>The big friendly giant</span>: huge companies counterweighted by supranational political institutions, allied to develop technology. Everything seems balanced, but how is individual freedom to choose and participate going to look like in this highly centralized scenario? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to learn more."
        }
        // row 7
        else if (this.results.x.global <= 2 && this.results.y.big === 1) {
          if (this.results.x.na >= 3) {
            this.resultsPhrase = "You think there's some evidence the future will look like what we call <span class='world'>The big friendly giant</span>: huge companies counterweighted by supranational political institutions. But it's hard to tell right? You are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          } else if (this.results.y.na >= 2) {
            this.resultPhrase = "You think there's some evidence the future will look like what we call <span class='world'>The big friendly giant</span>: huge companies counterweighted by supranational political institutions. But it's hard to tell right? You are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          } else {
            this.resultPhrase = "You think there's some evidence the future will look like what we call <span class='world'>The big friendly giant</span>: huge companies counterweighted by supranational political institutions. But you are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          }
        }
        // row 8
        else if (this.results.x.global >= 3 && this.results.y.big === 1) {
          if (this.results.y.na >= 2) {
            this.resultPhrase = "You think there's some evidence the future will look like what we call <span class='world'>The big friendly giant</span>: huge companies counterweighted by supranational political institutions. But it's hard to tell when it comes to firms, right? You are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          } else {
            this.resultPhrase = "You imagine a future where supranational institutions rule over some big companies, though there are some place for small startups. We call this <span class='world'>The big friendly giant</span>. But you are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          }
        }
        // row 9
        else if (this.results.x.global <= 2 && this.results.y.big >= 2) {
          if (this.results.x.na >= 3) {
            this.resultPhrase = "You think there's some evidence the future will look like what we call <span class='world'>The big friendly giant</span>: huge companies counterweighted by supranational political institutions. But it's hard to tell when it comes to governments, right? You are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          } else {
            this.resultPhrase = "You imagine a future where mega companies rules and are somehow counterweighted by a few supranational institutions. We call this <span class='world'>The big friendly giant</span>. But you are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          }
        }

        // Small under global rule
        // row 10
        else if (this.results.x.global >= 3 && this.results.y.small >= 2) {
          this.resultPhrase = "You imagine a future that we call <span class='world'>The small under global rule</span>: global institutions ruling over a network of local firms. Governments can deal with global issues and inequality seems out of date. But will workers going to be able to choose where to live? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to learn more."
        }
        // row 11
        else if (this.results.x.global <= 2 && this.results.y.small === 1) {
          if (this.results.x.na >= 3) {
            this.resultsPhrase = "You think there's some evidence the future will look like what we call <span class='world'>The small under global rule</span>: global governance coexisting with a decentralized economy. But it's hard to tell right? You are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          } else if (this.results.y.na >= 2) {
            this.resultPhrase = "You think there's some evidence the future will look like what we call <span class='world'>The small under global rule</span>: global governance coexisting with a decentralized economy. But it's hard to tell right? You are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          } else {
            this.resultPhrase = "You think there's some evidence the future will look like what we call <span class='world'>The small under global rule</span>: global governance coexisting with a decentralized economy. But you are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          }
        }
        // row 12
        else if (this.results.x.global >= 3 && this.results.y.small === 1) {
          if (this.results.y.na >= 2) {
            this.resultPhrase = "You think there's some evidence the future will look like what we call <span class='world'>The small under global rule</span>: global governance coexisting with a decentralized economy. But it's hard to tell when it comes to firms, right? You are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          } else {
            this.resultPhrase = "You imagine a future where supranational institutions rules over a myriad of small companies, though there are some economic concentration going on. We call this <span class='world'>The small under global rule</span>. But you are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          }
        }
        // row 13
        else if (this.results.x.global <= 2 && this.results.y.small >= 2 && this.results.x.local < 3) {
          if (this.results.x.na >= 3) {
            this.resultPhrase = "You think there's some evidence the future will look like what we call <span class='world'>The small under global rule</span>: global governance coexisting with a decentralized economy. But it's hard to tell when it comes to governments, right? You are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          } else {
            this.resultPhrase = "You imagine a future where small interconnected firms lead economic growth while some supranational institutions rule on politics. We call this <span class='world'>The small under global rule</span>. But you are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          }
        }

        // Small is beautiful
        // row 14
        else if (this.results.x.local >= 3 && this.results.y.small >= 2) {
          this.resultPhrase = "You imagine a future that we call <span class='world'>Small is beautiful?</span>. Local governments and small firms configures a scenario where diverse identities thrive but regional disparities deepen. Could this even lead to technological regression? <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to learn more."
        }
        // row 15  
        else if (this.results.x.local <= 2 && this.results.y.small === 1) {
          if (this.results.x.na >= 3) {
            this.resultsPhrase = "You think there's some evidence the future will look like what we call <span class='world'>Small is beautiful?</span> A fragmented world both politically and economically. But it's hard to tell right? You are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          } else if (this.results.y.na >= 2) {
            this.resultPhrase = "You think there's some evidence the future will look like what we call <span class='world'>Small is beautiful?</span> A fragmented world both politically and economically. But it's hard to tell right? You are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          } else {
            this.resultPhrase = "You think there's some evidence the future will look like what we call <span class='world'>Small is beautiful?</span> A fragmented world both politically and economically. But you are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          }
        }
        // row 16
        else if (this.results.x.local >= 3 && this.results.y.small === 1) {
          if (this.results.y.na >= 2) {
            this.resultPhrase = "You think there's some evidence the future will look like what we call <span class='world'>Small is beautiful?</span> A fragmented world both politically and economically. But it's hard to tell when it comes to firms, right? You are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          } else {
            this.resultPhrase = "You imagine a future where local governments take the lead and small firms work together, though there could be some economic concentration going on. We call this <span class='world'>Small is beautiful?</span> But you are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          }
        }
        // row 17
        else if (this.results.x.local <= 2 && this.results.y.small >= 2) {
          if (this.results.x.na >= 3) {
            this.resultPhrase = "You think there's some evidence the future will look like what we call <span class='world'>Small is beautiful?</span> A fragmented world both politically and economically. But it's hard to tell when it comes to governments, right? You are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          } else {
            this.resultPhrase = "You imagine a future where small interconnected and local governments coexist in a very fragmented scenario. We call this <span class='world'>Small is beautiful?</span> But you are not so far away from other possible worlds. <a href='http://bit.do/cippec-scrolly' target='_blank'>Tap here</a> to explore them all."
          }
        }
      }



      


      console.log(this.results)

      this.displayScores = true

      this.$nextTick(() => {
        let axisWidth = this.$refs.axis.offsetWidth
        let axisHeight = this.$refs.axis.offsetHeight
        let maxX = 6
        let maxY = 4
        let stepX = (axisWidth / 2) / maxX
        let stepY = (axisHeight / 2) / maxY
        
        let posX = (axisWidth * .5) + ((this.results.x.global - this.results.x.local) * stepX)
        let posY = (axisHeight * .5) + ((this.results.y.small - this.results.y.big) * stepY)

        if (posX > axisWidth) posX = axisWidth - 20
        if (posY > axisHeight) posY = axisHeight - 20
        
        this.$refs.pin.style.left = posX + 'px'
        this.$refs.pin.style.top = posY + 'px'
      })
    },
    saveScores (scores) {
      
      let gid = Math.round(Math.random() * 1000) + '' + (new Date()).getTime()
      let dataSave = scores.map(item => {
        return {
          gid: gid,
          name: this.name ? this.name : 'test',
          country: this.place ? this.name : 'test',
          area_id: item.aid,
          area_slug: item.area,
          question_id: item.id,
          answer: item.body,
          score: item.score,
          date: (new Date()).toISOString()
        }
      })
      dataSave = this.multiSort(dataSave, {area_slug: 'ASC', area_id: 'ASC'})
      axios.post(process.env.VUE_APP_API_URL, {
        data: dataSave
      }).then(response => {
        console.log(response.data)
      }).catch(e => {
        console.log(e)
      })
    },
    getAnswersAverage (answers) {
      let total = this.getAnswersAggregated(answers)
      return total / answers.length
    },
    getAnswersAggregated(answers) {
      let total = answers.reduce((total, item) => total + parseInt(item.score), 0)
      return total
    },
    highlight (bar) {
      // if (bar.ref) this.barsHighlight = bar.ref
    },
    dehighlight (bar) {
      // if (bar.ref) this.barsHighlight = null
    },
    toggleHighlight (bar) {
      if (bar.ref) {
        if (this.barsHighlight) {
          if (this.barsHighlight === bar.ref) {
            this.barsHighlight = null
          } else {
            this.barsHighlight = bar.ref
          }
        } else {
          this.barsHighlight = bar.ref
        }
      } else {
        this.barsHighlight = null
      }
    },
    toggleAverage () {
      if (this.loadedAverages) {
        this.displayAverage = !this.displayAverage
      } else {
        this.loadingAverages = true
        axios.get(process.env.VUE_APP_API_URL).then(response => {
          
          let users = []
          response.data.forEach(item => {
            let user = users.find(user => user.gid === item.gid)
            if (!user) {
              users.push({ gid: item.gid, answers: [item], grouped: {
                concentration_of_power: [],
                socioeconomic_inclusion: [],
                size_firms: [],
                gloal_coordination: []
              }, aggregated: {
                concentrationOfPower: 0,
                socioeconomicInclusion: 0,
                sizeFirms: 0,
                globalCoordination: 0
              }})
            } else {
              user.answers.push(item)
            }
          })
          users.forEach(user => {
            user.answers.forEach(answer => {
              user.grouped[answer.area_slug].push(answer)
            })
            user.aggregated.concentrationOfPower = this.getAnswersAggregated(user.grouped.concentration_of_power)
            user.aggregated.socioeconomicInclusion = this.getAnswersAggregated(user.grouped.socioeconomic_inclusion)
            user.aggregated.sizeFirms = this.getAnswersAggregated(user.grouped.size_firms)
            user.aggregated.globalCoordination = this.getAnswersAggregated(user.grouped.gloal_coordination)
          })
          this.averages.concentrationOfPower = users.reduce((total, user) => total + user.aggregated.concentrationOfPower, 0) / users.length
          this.averages.socioeconomicInclusion = users.reduce((total, user) => total + user.aggregated.socioeconomicInclusion, 0) / users.length
          this.averages.sizeFirms = users.reduce((total, user) => total + user.aggregated.sizeFirms, 0) / users.length
          this.averages.globalCoordination = users.reduce((total, user) => total + user.aggregated.globalCoordination, 0) / users.length
          this.displayAverage = true
          this.loadedAverages = true
          this.loadingAverages = false
        }).catch(e => {
          console.log(e)
        })
      }
    },
    showShare () {
      this.sharing = true
    },
    doneSharing () {
      //
    },
    clickOutside () {
      if (this.barsHighlight)
      {
        this.toggleHighlight({
          ref: this.barsHighlight
        })
      }
      
    },
    multiSort (array, sortObject = {}) {
      const sortKeys = Object.keys(sortObject);
      if (!sortKeys.length) {
        return array
      }
      // Change the values of the sortObject keys to -1, 0, or 1.
      for (let key in sortObject) {
        sortObject[key] = sortObject[key] === 'desc' || sortObject[key] === -1 ? -1 : (sortObject[key] === 'skip' || sortObject[key] === 0 ? 0 : 1);
      }
      const keySort = (a, b, direction) => {
        direction = direction !== null ? direction : 1 
        if (a === b) { // If the values are the same, do not switch positions.
          return 0
        }
        // If b > a, multiply by -1 to get the reverse direction.
        return a > b ? direction : -1 * direction
      }
      return array.sort((a, b) => {
        let sorted = 0
        let index = 0
        // Loop until sorted (-1 or 1) or until the sort keys have been processed.
        while (sorted === 0 && index < sortKeys.length) {
          const key = sortKeys[index]
          if (key) {
            const direction = sortObject[key]
            sorted = keySort(a[key], b[key], direction)
            index++
          }
        }
        return sorted
      })
    }
  }
}
